/* Create Application Fee */
import { type PAYMENT_TYPE } from '../../../components';

export enum ApplicationFeeStatus {
  WAIVED = 'WAIVED',
  NOT_CREATED = 'NOT_CREATED',
  PAID = 'PAID',
  NOT_PAID = 'NOT_PAID',
  PAST_DUE = 'PAST_DUE',
  CANCELLED = 'CANCELLED',
  SUSPENDED = 'SUSPENDED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export type PaymentRecordPayload = {
  paymentType: PAYMENT_TYPE;
  applicationNo: string;
  entryYear: string;
  department: string;
  programme: string;
  studyMode: string;
  paymentDeadline: string;
  paymentStatus: ApplicationFeeStatus;
  redirectUrl: string;
  paymentRedirectUrlInfo: any; // object form info redirect to FO payment
};
